import { useEffect } from "react";
import { useQuery } from "@tanstack/react-query";
import * as api from "../lib/api.ts";
import { hueIndex } from "../lib/hue.ts";

/**
 * Put the whole screen in a session's colours while this page is shown: the
 * light behind it, its titles, its action button. Null leaves the app's own.
 * Set on the root so the change fades (see --hue-a in styles.css).
 */
export function useHue(position: number | null): void {
  useEffect(() => {
    if (position === null) return;
    const root = document.documentElement;
    root.dataset.hue = String(hueIndex(position));
    return () => {
      delete root.dataset.hue;
    };
  }, [position]);
}

/** The colours of the cycle's session a workout was started from. */
export function useSessionHue(templateId: number | null | undefined): void {
  const cycle = useQuery({ queryKey: ["cycle"], queryFn: api.getCycle });
  const template = cycle.data?.cycle?.templates.find((candidate) => candidate.id === templateId);
  useHue(template?.position ?? null);
}
